// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationWarningTriangle: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#daa91c", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 18 17" width={width} height={height}>
            <path
                fill="currentColor"
                d="M1.213 14.246a.7.7 0 0 0-.088.333.65.65 0 0 0 .647.657h14.456a.65.65 0 0 0 .647-.657.7.7 0 0 0-.088-.333L9.721 1.94A.84.84 0 0 0 9 1.518c-.295 0-.57.16-.72.421zm-.97-.578L7.309 1.36C7.661.75 8.304.375 9 .375s1.34.375 1.691.986l7.066 12.307c.159.275.243.59.243.907 0 .993-.795 1.8-1.772 1.8H1.772c-.977 0-1.772-.807-1.772-1.8 0-.318.084-.632.243-.907M9 4.946a.57.57 0 0 1 .563.572v4.571a.57.57 0 0 1-.563.572.57.57 0 0 1-.562-.572V5.518A.57.57 0 0 1 9 4.946m-.844 8A.85.85 0 0 1 9 12.09a.85.85 0 0 1 .844.857.85.85 0 0 1-.844.858.85.85 0 0 1-.844-.858"
            />
        </svg>
    );
};

export default React.memo(NotificationWarningTriangle);
